import { RouterProvider } from "@/router/RouterProvider"
import { Bounce, ToastContainer } from "react-toastify"
import ThemeLayout from "./layouts/ThemeLayout"
import AppEffects from "./AppEffects"
import { createLogger } from "./utils/logger"

const logger = createLogger("App")

function App() {
    logger.debug("App Render")
    return (
        <ThemeLayout>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                transition={Bounce}
            />
            <AppEffects />
            <RouterProvider />
        </ThemeLayout>
    )
}

export default App
